import React from 'react';
import {clsx} from 'clsx';
import {Typography} from 'onboarding-components';

import {useTranslation} from 'common/i18n/hooks';
import common from 'iron/common/onboarding/immersive-onboarding/steps/common.module.styl';
import {VerifiedBox} from 'iron/common/onboarding/immersive-onboarding/components/event-status-box/event-status-box';

import {NeedHelpTileButtons} from './need-help-button-bar';

export const VerifyConnection = () => {
  const {t} = useTranslation();

  return (
    <div className={common.container}>
      <header>
        <Typography className={clsx(common.mt0, common.mb8)} variant='headingSm'>
          {t(`onboarding.verify.verify-connection`)}
        </Typography>
        <Typography variant='bodySm'>{t(`onboarding.verify.verify-connection-description`)}</Typography>
        <VerifiedBox className={common.mt24} />
        <NeedHelpTileButtons />
      </header>
    </div>
  );
};
